import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import handleApiError from "../../helpers/handleApiError";
import fileDownload from "js-file-download";
import {
  getParcelImage,
  getPublicTrackerParcelImage,
} from "../../services/deliveryService";
import { BsX } from "react-icons/bs";
import { isClient } from "../../services/accountService";
import cdkDemoPODImage from "../../assets/demo assets/CC Example POD image.jpg";

export const FullPageParcelImageModal = ({
  show,
  handleCloseModal,
  selectedImage,
  barcode,
  invoice,
  textUnderImage,
  isPublicTracker,
  isDemoAccount,
}) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [imageData, setImageData] = useState(); //currently using {base64EncodedData, description, updatedWhen:{formattedDate, formattedTime}}
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        setIsLoading(true);
        // console.log("hi");
        // const dontintercept = axios.create();
        // const imageResponse = await dontintercept.get(imageURLToFetch, {
        //   headers: { Authorization: "Token 5b6c3163c95e4110ab7324399ac0cb4e" },
        //   params: { convertTo: "JPG" },
        // });
        const imageEndpoint = isPublicTracker
          ? getPublicTrackerParcelImage
          : getParcelImage;
        if (isDemoAccount) {
          setImageData({
            base64EncodedData: cdkDemoPODImage,
            description: "Package Delivered",
            updatedWhen: {
              formattedDate: new Date().toLocaleDateString("en-US"),
              formattedTime: "3:52 PM",
            },
          });
        } else {
          const imageResponse = await imageEndpoint(selectedImage, isClient()); //for public tracker isClient() is disregarded but shouldn't cause an issue for now
          if (isMounted) {
            // console.log(imageResponse);
            setImageData(imageResponse.data);
          }
        }
        if (isMounted) {
          setIsLoading(false);
        }
      } catch (ex) {
        handleApiError(ex, history);
        // console.log(ex);
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    //only if show is true do we actually want to run the mount code //may be a better pattern to do this
    if (show && selectedImage) {
      // console.log(selectedImage);
      fetchData();
    }

    return () => {
      isMounted = false;
    };
  }, [show, selectedImage, history]);

  const downloadImageClick = async () => {
    // console.log(imageData?.base64EncodedData);
    let imageToDownloadResponse = await fetch(
      isDemoAccount
        ? imageData?.base64EncodedData
        : "data:image/jpg;base64," + imageData?.base64EncodedData,
    );
    let imageToDownload = await imageToDownloadResponse.blob();

    const typeFile = barcode
      ? `Diligent Barcode ${barcode}`
      : `Diligent Invoice ${invoice}`;

    fileDownload(
      imageToDownload,
      `${typeFile} - ${imageData.description} - ${imageData?.updatedWhen?.formattedDate} at ${imageData?.updatedWhen?.formattedTime}.jpg`,
      "image/jpg",
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      className="full-page-parcel-image-modal-container"
      dialogClassName="full-page-parcel-image-modal-dialog"
      contentClassName="full-page-parcel-image-modal-content"
      animation={false}
    >
      {isLoading ? (
        <div
          className="spinner-border"
          role="status"
          style={{
            color: "white",
            position: "absolute",
            top: "calc(50% - 1.5rem)",
            left: "calc(50% - 1.5rem)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          <div
            className="full-page-parcel-image-modal-title"
            style={{ position: "relative" }}
          >
            {!textUnderImage && (
              <>
                {barcode && (
                  <p className="h4" style={{ margin: 0 }}>
                    Barcode {barcode}
                  </p>
                )}

                {invoice && (
                  <p className="h4" style={{ margin: 0 }}>
                    Invoice {invoice}
                  </p>
                )}

                <p className="h5">
                  On{" "}
                  {imageData?.updatedWhen?.formattedDate +
                    " at " +
                    imageData?.updatedWhen?.formattedTime}
                  <br />
                  Description: <br /> {imageData?.description}
                </p>
              </>
            )}
            <div
              role="button"
              className="d-none d-sm-block"
              onClick={handleCloseModal}
              style={{ position: "absolute", top: 0, right: 0 }}
            >
              <BsX
                size={45}
                style={{
                  margin: "-7px",
                  filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
                }}
              />
            </div>
          </div>
          {imageData && (
            <img
              className="full-page-parcel-image-modal-img"
              src={
                isDemoAccount
                  ? imageData?.base64EncodedData
                  : "data:image/jpg;base64," + imageData?.base64EncodedData
              }
              alt="Signature"
            />
          )}
          <div className="d-flex align-items-center flex-column mt-2">
            {textUnderImage && (
              <div
                className="full-page-parcel-image-modal-title"
                style={{ textAlign: "center" }}
              >
                <p className="h4" style={{ margin: 0 }}>
                  Barcode {barcode}
                  {/* <br />
              File:
              {" " + imageData?.fileName} */}
                </p>
                <p className="h5">
                  {imageData?.updatedWhen?.formattedDate +
                    " " +
                    imageData?.updatedWhen?.formattedTime}
                  <br />
                  Description: <br /> {imageData?.description}
                </p>
              </div>
            )}
            <button
              style={{ width: "500px", justifySelf: "center" }}
              className="btn btn-primary mb-1"
              onClick={downloadImageClick}
            >
              Download
            </button>
            <button
              style={{ width: "500px", justifySelf: "center" }}
              className="btn btn-secondary mb-1"
              onClick={handleCloseModal}
            >
              Close
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};
